export function generateSeperatorTags() {
  const placeholder = {
    type: 'placeholder',
    width: 4
  };

  const seperatorTags = [
    placeholder,
    {
      type: 'text',
      fontSize: 12,
      fontFamily: Mach.env.isIOS ? 'KeeTa-Bold' : 'KeeTa-Regular',
      text: '·',
      color: '#C2C2C2',
      fontWeight: Mach.env.isIOS ? 400 : 800,
      lineHeight: 18,
    },
    placeholder,

  ];
  return seperatorTags;
}
